module.exports = __webpack_public_path__ + "img/intro-background.6f66dccc.jpg";